"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactNewWindowStyles = void 0;
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var styled_components_1 = require("styled-components");
var ReactNewWindowStyles = /** @class */ (function (_super) {
    __extends(ReactNewWindowStyles, _super);
    function ReactNewWindowStyles(props) {
        var _this = _super.call(this, props) || this;
        _this.closeExternalWindow = function () {
            if (_this.state.externalWindow && !_this.state.externalWindow.closed) {
                _this.state.externalWindow.close();
            }
        };
        _this.state = {
            externalWindow: null,
        };
        _this.container = document.createElement('div');
        return _this;
    }
    ReactNewWindowStyles.prototype.componentDidMount = function () {
        var _this = this;
        this.setState({
            externalWindow: window.open('', this.props.name, this.windowPropsToString()),
        }, function () {
            if (_this.state.externalWindow != null) {
                _this.state.externalWindow.onunload = _this.props.onClose;
                var title = _this.state.externalWindow.document.createElement('title');
                title.innerText = !!_this.props.title ? _this.props.title : '';
                _this.state.externalWindow.document.head.appendChild(title);
                _this.state.externalWindow.document.body.appendChild(_this.container);
                if (_this.props.copyStyles) {
                    setTimeout(
                    // @ts-ignore
                    function () { return copyStyles(document, _this.state.externalWindow.document); }, 0);
                }
                // Inject global style
                Array.from(document.head.getElementsByTagName('STYLE'))
                    .filter(function (style) {
                    return style.innerText.indexOf('\n/* sc-component-id: sc-global') != -1;
                })
                    .forEach(function (style) {
                    if (_this.state.externalWindow != null) {
                        _this.state.externalWindow.document.head.appendChild(style.cloneNode(true));
                    }
                });
            }
        });
        if (this.props.autoClose) {
            window.addEventListener('unload', this.closeExternalWindow);
        }
    };
    ReactNewWindowStyles.prototype.componentDidUpdate = function (prevProps) {
        if (!prevProps.autoClose && this.props.autoClose) {
            // autoClose became enabled
            window.addEventListener('unload', this.closeExternalWindow);
        }
        if (prevProps.autoClose && !this.props.autoClose) {
            // autoClose became disabled
            window.removeEventListener('unload', this.closeExternalWindow);
        }
    };
    ReactNewWindowStyles.prototype.componentWillUnmount = function () {
        if (this.props.autoClose) {
            window.removeEventListener('unload', this.closeExternalWindow);
        }
        this.closeExternalWindow();
    };
    ReactNewWindowStyles.prototype.windowPropsToString = function () {
        var _this = this;
        var mergedProps = __assign(__assign({}, ReactNewWindowStyles.defaultProps.windowProps), this.props.windowProps);
        return Object.keys(mergedProps)
            .map(function (key) {
            switch (typeof mergedProps[key]) {
                case 'function':
                    return key + "=" + mergedProps[key].call(_this, mergedProps, window);
                case 'boolean':
                    return key + "=" + (mergedProps[key] ? 'yes' : 'no');
                default:
                    return key + "=" + mergedProps[key];
            }
        })
            .join(',');
    };
    ReactNewWindowStyles.prototype.render = function () {
        if (!!this.state.externalWindow) {
            return (react_1.default.createElement(styled_components_1.StyleSheetManager, { target: this.state.externalWindow.document.head },
                react_1.default.createElement("div", null, react_dom_1.default.createPortal(this.props.children, this.container))));
        }
        else {
            return null;
        }
    };
    ReactNewWindowStyles.defaultProps = {
        onClose: function () { },
        title: 'New Window',
        name: '',
        copyStyles: false,
        windowProps: {
            toolbar: false,
            location: false,
            directories: false,
            status: false,
            menubar: false,
            scrollbars: true,
            resizable: true,
            width: 500,
            height: 400,
            top: function (props, window) {
                return window.screen.height / 2 - window.outerHeight / 2;
            },
            left: function (props, window) {
                return window.screen.width / 2 - window.outerWidth / 2;
            },
        },
    };
    return ReactNewWindowStyles;
}(react_1.default.PureComponent));
exports.ReactNewWindowStyles = ReactNewWindowStyles;
function copyStyles(source, target) {
    Array.from(source.styleSheets).forEach(function (styleSheet) {
        // For <style> elements
        var rules;
        try {
            rules = styleSheet.cssRules;
        }
        catch (err) {
            console.error(err);
        }
        if (rules) {
            var newStyleEl_1 = source.createElement('style');
            // Write the text of each rule into the body of the style element
            Array.from(styleSheet.cssRules).forEach(function (cssRule) {
                var cssText = cssRule.cssText, type = cssRule.type;
                var returnText = cssText;
                // Check if the cssRule type is CSSImportRule (3) or CSSFontFaceRule (5) to handle local imports on a about:blank page
                // '/custom.css' turns to 'http://my-site.com/custom.css'
                if ([3, 5].includes(type)) {
                    returnText = cssText
                        .split('url(')
                        .map(function (line) {
                        if (line[1] === '/') {
                            return "" + line.slice(0, 1) + window.location.origin + line.slice(1);
                        }
                        return line;
                    })
                        .join('url(');
                }
                newStyleEl_1.appendChild(source.createTextNode(returnText));
            });
            target.head.appendChild(newStyleEl_1);
        }
        else if (styleSheet.href) {
            // for <link> elements loading CSS from a URL
            var newLinkEl = source.createElement('link');
            newLinkEl.rel = 'stylesheet';
            newLinkEl.href = styleSheet.href;
            target.head.appendChild(newLinkEl);
        }
    });
}
